var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleAdk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google_adk_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h256v512H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google_adk_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 0h256v512H256z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -10)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 154,
  y: 150,
  width: 204,
  height: 116,
  rx: 58,
  ry: 58,
  fill: "none",
  stroke: "#4285F4",
  strokeWidth: 32,
  strokeLinecap: "round",
  clipPath: "url(#google_adk_svg__a)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 154,
  y: 150,
  width: 204,
  height: 116,
  rx: 58,
  ry: 58,
  fill: "none",
  stroke: "#34A853",
  strokeWidth: 32,
  strokeLinecap: "round",
  clipPath: "url(#google_adk_svg__b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 208,
  r: 16,
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 300,
  cy: 208,
  r: 16,
  fill: "#4285F4"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M210 314h-36a12 12 0 0 0-12 12v72a12 12 0 0 0 12 12h36",
  fill: "none",
  stroke: "#FBBC05",
  strokeWidth: 32,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m284 314-38 48 38 48M346 314l38 48-38 48",
  fill: "none",
  stroke: "#EA4335",
  strokeWidth: 32,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgGoogleAdk as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/google_adk.svg";